import React from 'react';
import ScrollComponent from '../../../common/ScrollComponent';
import Loading from '../../../common/loading/Loading';
import EventEmitter, { LOAD_WORKSPACE } from '../../../helpers/EventEmitter';
import Const from '../Const';
import Link from '../../../common/tab';
import Responsive from '../../../common/responsive/Responsive';
import { getUnique } from '../../../helpers/Common';
import LayoutHelper from '../../../helpers/Layout';
import { nameSaveStateDefault } from '../../../../configs/LayoutConfig';
import {
  confirmRemoveWorkspace,
  deleteWorkspace,
  fetchDataWorkspace,
  REDUCER_NAME,
  showConfirmRemoveWorkspace,
  editWorkspace,
  toggleShowValidateWorkspaceName,
  toggleConfirmRemoveWorkspace,
} from '../reducer';
import connect from 'react-redux/es/connect/connect';
import ConfirmPopup from '../../../common/popup/ConfirmPopup';
import { I18n } from 'react-redux-i18n';
import currentState from './../../../helpers/CurrentState';
import Validation from '../../../helpers/Validation';
import { ConfirmPopup as ValidateWorkspaceName } from '../../../common/popup';

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workspaceEdit: {
        isShowConfirmEdit: false,
        id: 0,
      },
      changeWorkspaceName: '',
    };
  }
  componentDidMount() {
    const { fetchDataWorkspace } = this.props;
    fetchDataWorkspace();
  }

  componentWillUnmount() {
    const {
      toggleConfirmRemoveWorkspace,
      isShowConfirmRemoveWorkspace,
    } = this.props;
    if (isShowConfirmRemoveWorkspace) {
      toggleConfirmRemoveWorkspace(false);
    }
  }

  handleDeleteWorkspace = workspaceId => () => {
    const { showConfirmRemoveWorkspace } = this.props;
    showConfirmRemoveWorkspace(workspaceId);
  };

  handleApplyWorkspace = (workspace, showHide) => () => {
    currentState.apply(JSON.parse(workspace).data);
    EventEmitter.dispatch(LOAD_WORKSPACE);
    LayoutHelper.saveState(nameSaveStateDefault, workspace);
    LayoutHelper.reload(JSON.parse(workspace));
    showHide(false);
  };

  handleWorkspaceEditer = workspaceId => {
    const { workspaceEdit } = this.state;
    let cloneWorkSpace = {
      isShowConfirmEdit: !workspaceEdit.isShowConfirmEdit,
      id: workspaceId,
    };
    this.setState({ workspaceEdit: cloneWorkSpace, changeWorkspaceName: '' });
  };

  toggerEditWorkspaceName = workspaceId => () => {
    this.handleWorkspaceEditer(workspaceId);
  };

  renderEdit = workspaceId => {
    return (
      <span
        className="ml-5 mr-5"
        style={{ cursor: 'pointer' }}
        onClick={this.toggerEditWorkspaceName(workspaceId)}
      >
        <i className="icon-pencil-edit fs-12 text-stock-chart" />
      </span>
    );
  };

  renderDelete = workspaceId => {
    return (
      <span
        onClick={this.handleDeleteWorkspace(workspaceId)}
        style={{ cursor: 'pointer' }}
      >
        <i className="icon-bin-delete fs-12 text-stock-chart" />
      </span>
    );
  };

  changeInputText = e => {
    this.setState({ ...this.state, changeWorkspaceName: e.target.value });
  };

  validateWorkspaceName = name => {
    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
    return messages;
  };

  handleEditWorkspace = (nameChange, workspaceId, nameOfWorkspace) => () => {
    const { editWorkspace, toggleShowValidateWorkspaceName } = this.props;
    if (nameOfWorkspace && !nameChange.length > 0) {
      editWorkspace(nameOfWorkspace, workspaceId);
    } else {
      const errorMessage = this.validateWorkspaceName(nameChange);
      if (errorMessage.length > 0) {
        toggleShowValidateWorkspaceName(
          true,
          'message.invalid_name_workspace',
          errorMessage[0],
        );
      } else {
        editWorkspace(nameChange, workspaceId);
      }
    }
    this.handleWorkspaceEditer(workspaceId);
  };

  renderBottomImage = (type, name, workspaceId) => {
    const { workspaceEdit, changeWorkspaceName } = this.state;
    if (workspaceEdit.isShowConfirmEdit && workspaceEdit.id === workspaceId) {
      return (
        <div className="text-center">
          <div className="d-flex justify-content-center" style={{ height: 18 }}>
            <input
              className="text-input"
              autoFocus
              type="text"
              style={{ width: 250 }}
              onChange={e => this.changeInputText(e)}
              defaultValue={name}
            />
            <span className="float-right">
              <span
                style={{ cursor: 'pointer' }}
                className="text-s-color-5 fs-16 mr-5"
                onClick={this.handleEditWorkspace(
                  changeWorkspaceName,
                  workspaceId,
                  name,
                )}
              >
                <i className="icon-correct" />
              </span>
              <span
                style={{ cursor: 'pointer' }}
                className="text-s-color-3 fs-13 mr-5"
                onClick={this.toggerEditWorkspaceName(workspaceId)}
              >
                <i className="icon-remove-symbol" />
              </span>
            </span>
          </div>
        </div>
      );
    } else {
      return (
        <div className="text-center ">
          <span className="workspace-name">{name}</span>
          {/*<input*/}
          {/*className="text-input"*/}
          {/*type="text"*/}
          {/*onChange={() => {}}*/}
          {/*ref={this.inputEditRef}*/}
          {/*defaultValue={name}*/}
          {/*/>*/}
          {type === Const.TYPE_WORKSPACE.USER && (
            <>
              {this.renderEdit(workspaceId)} {this.renderDelete(workspaceId)}
            </>
          )}
        </div>
      );
    }
  };

  renderGroup = (type, data, title, showHide, width = 640) => {
    return (
      <div>
        <div className="top-nav">
          <Link isLineLinkLeft={true} currentTab={1} listTab={title} />
        </div>
        <div className="list" style={{ width }}>
          <Responsive
            component={{ width }}
            margin={10}
            SM_SIZE={700}
            XS_SIZE={200}
            numColumnXsSize={2}
            isMinNumColumnAndLenData={false}
          >
            {data.map(({ thumbnails, name, workspaceId, workspace }, index) => {
              return width => (
                <div>
                  <div style={{ minHeight: 135 }}>
                    <img
                      onClick={this.handleApplyWorkspace(workspace, showHide)}
                      width={width}
                      key={getUnique() + index}
                      src={thumbnails}
                      alt=""
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  {this.renderBottomImage(type, name, workspaceId)}
                </div>
              );
            })}
          </Responsive>
        </div>
      </div>
    );
  };

  render() {
    const {
      listWorkspaceUser,
      listWorkspaceSystem,
      isLoading,
      confirmRemoveWorkspace,
      isShowConfirmRemoveWorkspace,
      showHide,
      workspaceValidate,
      toggleShowValidateWorkspaceName,
    } = this.props;
    const { isShowValidateWorkspaceName, title, message } = workspaceValidate;

    return (
      <div>
        <ConfirmPopup
          title={I18n.t('message.delete_title')}
          isShow={isShowConfirmRemoveWorkspace}
          messages={[I18n.t('message.remove_message', { name: 'Workspace' })]}
          confirm={confirmRemoveWorkspace}
          iconName={'icon-help'}
        />
        <ValidateWorkspaceName
          title={I18n.t(title)}
          messages={[message]}
          isShow={isShowValidateWorkspaceName}
          enabledCancel={false}
          enabledApply={false}
          iconName={'icon-warning'}
          confirm={toggleShowValidateWorkspaceName}
        />

        <ScrollComponent appendStyle={{ maxHeight: 300 }}>
          <div className="group-list drop-100">
            <div className="pl-20 pr-20 position-relative">
              {isLoading && <Loading />}
              {this.renderGroup(
                Const.TYPE_WORKSPACE.SYSTEM,
                listWorkspaceSystem,
                'layout.workspace.recommendedForYou',
                showHide,
              )}
              {this.renderGroup(
                Const.TYPE_WORKSPACE.USER,
                listWorkspaceUser,
                'layout.workspace.workspaces',
                showHide,
              )}
            </div>
          </div>
        </ScrollComponent>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    listWorkspaceSystem: state[REDUCER_NAME].saveLayout.listWorkspaceSystem,
    listWorkspaceUser: state[REDUCER_NAME].saveLayout.listWorkspaceUser,
    isLoading: state[REDUCER_NAME].saveLayout.isLoading,
    isShowConfirmRemoveWorkspace:
      state[REDUCER_NAME].saveLayout.isShowConfirmRemoveWorkspace,
    workspaceValidate: state[REDUCER_NAME].saveLayout.workspaceValidate,
  };
};

const mapDispatchToProps = {
  fetchDataWorkspace,
  deleteWorkspace,
  confirmRemoveWorkspace,
  showConfirmRemoveWorkspace,
  editWorkspace,
  toggleShowValidateWorkspaceName,
  toggleConfirmRemoveWorkspace,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List);
